<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")
      v-card
        v-card-title.px-5(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T16}`")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal")
                v-icon(color="basic800" :size="24") mdi-close
            v-col.ml-3
              p.mb-0.h6.basic800--text {{ title ? title : $t('attach_products') }}

        v-card-text.pa-0
          v-container.white(style="max-width:600px")
            v-layout.mt-2
              v-text-field(v-model="searchText" placeholder='Search product' hide-details dense outlined height="40" background-color="basic200")
                template(v-slot:append)
                  eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600")
          
          v-container.px-1(style="max-width:600px")
            v-layout.my-6(v-if="isFetching")
              v-row.fill-height.ma-0(align='center' justify='center')
                v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
            .contain-layout(v-else)
              v-layout.my-6(v-if="products.length == 0")
                v-row.fill-height.ma-0(align='center' justify='center')
                  div.mx-auto
                    v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                    p.caption {{ $t('products_not_found') }}
              div(v-else)
                template(v-for="(product, index) in products")
                  v-card(flat @click="clickProduct(product, index)")
                    v-row(no-gutters )
                      v-col.shrink
                        v-img(:src="product.image ? product.image.file : require('@/assets/image_placeholder.png')" width="88px" aspect-ratio="1")
                          div.d-flex.justify-center.align-end(style="height: 100%" v-if="product.inventory_enabled")
                            v-chip.white--text.mb-2(x-small color="primary500") {{ getProductCount() }}
                      v-col.py-2.px-2
                        div.p1.basic800--text.mb-1 {{ product.name }}
                        div.c1.basic600--text.product-description.mb-1(v-html="product.description")
                      v-col.py-2.shrink.align-self-center
                        y-checkbox.ma-0.pa-0(v-model="product.selected" readonly)
                  v-divider.basic300
                
                  //- template(v-for="(product, index) in products")
                    v-list-item.pl-1.pr-3(:key="product.id" :class="product.selected? 'blue lighten-5' : ''" @click="clickProduct(product, index)")
                      v-card.elevation-0.ma-2(style="border-radius: 2px")
                        v-img(:src="product.image ? product.image.file : require('@/assets/image_placeholder.png')" height="70px" width="70px")
                      v-list-item-content
                        div {{ product.name }}
                        div.caption.text--secondary.mr-4(style="line-height: 1.2em;  min-height:14px;") {{ (product.description && product.description.length > 25) ? (product.description.substr(0,25) + '...') : product.description }}
                      v-list-item-action
                        y-checkbox(v-model="product.selected" readonly)
                    v-divider
              div.ma-4
                y-pagination(v-model="page" :pageSize="fetchCount" :count="count")

        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-small.primary400--text {{ $t('cancel') }}
          v-btn.mr-2(color='textColorAccent' depressed height=32  @click="clickDone" :loading="isLoading" dark)
            .button-AA-small.basic100--text {{ $t('done') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ShowMoreText from '@/components/ShowMoreText'

export default {
  name: 'AttachProducts',
  props: {
    open: {
      type: Boolean
    },
    initialProducts: {
      type: Array,
      default: () => {
        return []
      }
    },
    excludeBundles: {
      type: Boolean
    },
    title: {
      type: String
    }
  },
  components: { ShowMoreText },
  data: () => ({
    isFetching: false,
    fetchCount: 20,
    page: 1,
    // totalPage: 1,
    count: 0,
    products: [],
    selectedProducts: [],
    searchText: '',
    searchCountDown: null,
    isLoading: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {
    page(val) {
      if (!this.isFetching) {
        this.fetchProducts(val)
      }
    },
    searchText() {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.searchItem()
      }, 500)
    }
  },
  mounted() {
    this.selectedProducts = [...this.initialProducts]
    this.fetchProducts(1)
  },
  methods: {
    ...mapActions(['showMessage']),
    clickProduct(product, index) {
      this.products[index].selected = !this.products[index].selected
      this.updateProduct(this.products[index])
    },
    updateProduct(product) {
      if (product.selected) {
        this.addProduct(product)
      } else {
        this.removeProduct(product)
      }
    },
    addProduct(product) {
      this.selectedProducts.push(product.item)
    },
    removeProduct(product) {
      this.selectedProducts = this.selectedProducts.filter(x => x.id !== product.id)
    },
    getSelected(product) {
      let selprod = this.selectedProducts.filter(f => f.id === product.id)
      if (selprod.length > 0) {
        return true
      }
      return false
    },
    filterProperties(obj) {
      const allowedProperties = ['id', 'name', 'description', 'quantity', 'price', 'image']
      const filteredObj = this.$options.filters.filterAllowedObjectProperties(obj, allowedProperties)
      // Custom properties
      filteredObj.item = obj
      filteredObj.selected = this.getSelected(obj)

      return filteredObj
    },
    fetchProducts(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let fetchUrl = `/products/?page=${page}&page_size=${this.fetchCount}&company=${this.company.id}&ordering=-id`
      if (this.excludeBundles) {
        fetchUrl += `&bundle=false`
      }
      if (this.searchText) {
        fetchUrl += `&search=${this.searchText}`
      }
      this.$axios
        .get(fetchUrl)
        .then(response => {
          this.isFetching = false
          this.products = response.data.results.map(product => {
            return this.filterProperties(product)
          })
          this.count = response.data.count
        })
        .catch(() => {})
    },
    searchItem() {
      let searchUrl = `/products/?page=1&page_size=${this.fetchCount}&company=${this.company.id}&ordering=-id`
      if (this.excludeBundles) {
        searchUrl += `&bundle=false`
      }
      if (this.searchText) {
        searchUrl += `&search=${this.searchText}`
      }
      this.isFetching = true
      this.page = 1
      this.$axios
        .get(searchUrl)
        .then(response => {
          this.isFetching = false
          this.products = response.data.results.map(product => {
            return this.filterProperties(product)
          })
          this.count = response.data.count
        })
        .catch(() => {})
    },
    clickDone() {
      this.showModal = false
      this.$emit('update:initialProducts', this.selectedProducts)
    }
  }
}
</script>

<style scoped>
.product-description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "product_name": {
      "label": "Name",
      "placeholder": "Write product name here"
    },
    "price": {
      "label": "Price",
      "placeholder": "0"
    },
    "slash_price": {
      "label": "Slash Price/Normal Price before Discount",
      "placeholder": "0"
    },
    "weight": {
      "label": "Weight",
      "placeholder": "Min = 0.1 kg | Max = 60 kg"
    },
    "description": {
      "label": "Description",
      "placeholder": "Write product description here"
    },
    "quantity": {
      "label": "Quantity",
      "placeholder": "How many stock left"
    }
  },
  "id": {
    "product_name": {
      "label": "Nama",
      "placeholder": "Tulis nama produk di sini"
    },
    "price": {
      "label": "Harga",
      "placeholder": "0"
    },
    "slash_price": {
      "label": "Harga Slash/Harga Normal sebelum Diskon",
      "placeholder": "0"
    },
    "weight": {
      "label": "Berat",
      "placeholder": "Min = 0.1 kg | Maks = 60 kg"
    },
    "description": {
      "label": "Deskripsi",
      "placeholder": "Tulis Produk Deskripsi di sini"
    },
    "quantity": {
      "label": "Jumlah",
      "placeholder": "Stok tersisa"
    }
  }
}
</i18n>
